/** Held-back task work and the command that adds approved rows to an existing Job. */
import { TaskApprovalStatus } from './task.approval';

/** Stable Visit entity-data command identities. */
export enum VisitNotInJobCommandId {
    NotInJob = 'VisitNotInJobQuery',
    ApproveAndAddToJob = 'VisitApproveAndAddToJobCommand',
}

/** Reads work omitted from this Job's Visit. */
export interface VisitNotInJobRequest { id: string; }

/** An unlinked task on the construction sibling or awaiting a retried sync on the Job's Visit. */
export interface VisitNotInJobTask {
    visitTaskId: string;
    name: string;
    scheduledDate: string;
    approvalState?: TaskApprovalStatus.Approved | TaskApprovalStatus.NeedsReview;
}

/** Held-back work and the reviewed move authority used by Approve & add to Job. */
export interface VisitNotInJob {
    siblingVisitId?: string;
    tasks: VisitNotInJobTask[];
    addToJob: { allowed: boolean; reason?: string; fingerprint?: string };
}

/** A retry-stable request; a stale fingerprint returns a refreshed movement preview. */
export interface VisitApproveAndAddToJobRequest {
    id: string;
    requestId: string;
    fingerprint?: string;
}
